<template>
  <div class="row">
      <div class="col-md-12 col-xxl-12 col-sm-6 mb-10">
        <div class="card mb-25 border-0 rounded-0">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
              <!-- <router-link to="/ajouter-apropos" 
              class=" btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-plus  lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Ajouter</router-link> -->

              <h4 class="position-relative text-black fw-bold mb-10">Informations</h4>
              
              <!-- <router-link :to="{ name: 'EditAproposPage', params: { id: 1 } }" 
              class=" btn btn-primary transition border-0 lh-1 fw-medium" >
              <i class="flaticon-edit  lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Modifier</router-link> -->
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="bl">Image:</td>
                  <td><img :src="getUrlApiForFiles(apropos?.urlImage)" alt="Image"></td>
                </tr>
                <tr>
                  <td class="bl">Valeur:</td>
                  <td v-html="apropos?.valeur"></td>
                </tr>
                <tr>
                  <td class="bl">Vision:</td>
                  <td v-html="apropos?.vision"></td>
                </tr>
                <tr>
                  <td class="bl">Mission:</td>
                  <td v-html="apropos?.mission"></td>
                </tr>
                <tr>
                  <td class="bl">Historique:</td>
                  <td v-html="apropos?.historique"></td>
                </tr>
                <tr>
                  <td class="bl">Organigramme:</td>
                  <td>{{ apropos?.organigramme }}</td>
                </tr>
                <tr>
                  <td class="bl">Mot du DG:</td>
                  <td v-html="apropos?.annoncedg"></td>
                </tr>
                <tr>
                  <td class="bl">Mention legale:</td>
                  <td v-html="apropos?.mentionLegale"></td>
                </tr>
                <tr>
                  <td class="bl">Donnée personnelle:</td>
                  <td v-html="apropos?.donnePersonnelle"></td>
                </tr>
                <tr>
                  <td class="bl">Cookie:</td>
                  <td v-html="apropos?.cookie"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "../../services/ApiService";
import { Apropos } from "../../models/Apropos";
import { error, format_date,separateur,format_Date, getUrlApiForFiles } from "../../utils/utils";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ViewApropos",
  setup: () => {
    const route = useRoute();
    const apropos = ref<Apropos>();
    const aproposs = ref<Array<Apropos>>([]);

    function getApropos(id: string) {
      return ApiService.get("/apropos/"+id)
      .then(({ data }) => {
        apropos.value = data.data;
        console.log('erfgrfg', data.data)  
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    onMounted(() => {
      const id = route.params.id as string;
      getApropos(id);
    });

    return { apropos, getApropos, format_date,
      format_Date, aproposs,separateur,
      getUrlApiForFiles, };
  },
});
</script>

<style>
  .bl{
    font-weight: bold;
  }
</style>